import { number, string } from 'prop-types';

const billProcessReportDetailPropTypes = {
  id: number.isRequired,
  fromDate: number.isRequired,
  toDate: number.isRequired,
  status: string.isRequired,
  s3Key: string.isRequired,
  s3Url: string.isRequired,
  errorMessage: string,
  createDate: number.isRequired,
  lastUpdate: number.isRequired,
};

export default billProcessReportDetailPropTypes;
